import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { DebitsActions } from './debits.actions';
import { IDebitsState } from './debits.state';

export const initialDebitsState: IDebitsState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const debitsReducerFn = createReducer(
  initialDebitsState,
  on(DebitsActions.reset, (state: IDebitsState, action) => {
    return new StateBuilder<IDebitsState>(initialDebitsState).build();
  }),
  on(DebitsActions.updateModel, (state: IDebitsState, action) => {
    return new StateBuilder<IDebitsState>(state, action).toLoading().build();
  }),
  on(DebitsActions.load, (state: IDebitsState, action) => {
    return new StateBuilder<IDebitsState>(state).toLoading().build();
  }),
  on(DebitsActions.loadSuccess, (state: IDebitsState, action) => {
    return new StateBuilder<IDebitsState>(state, action).toLoaded().build();
  }),
  on(DebitsActions.submit, (state: IDebitsState) => {
    return new StateBuilder<IDebitsState>(state).toLoading().build();
  }),
  on(DebitsActions.submitSuccess, (state: IDebitsState, action) => {
    return new StateBuilder<IDebitsState>(state, action).toLoaded().build();
  })
);

export function debitsReducer(state: IDebitsState | undefined, action: Action) {
  return debitsReducerFn(state, action);
}
